<template>
  <page>
    <form>
      <message :messages="messages"></message>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-calendar-range</v-icon>
            <v-toolbar-title>Accounting Period (Month/Year)</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field v-model="form.acctPer" :label="labels.acctPer" :error-messages="errors.collect('acctPer')"
                :data-vv-as="labels.acctPer" data-vv-name="acctPer" append-icon="mdi-magnify" readonly v-validate="'required'"
                :loading="submitting"
                @click:append="showAcctPeriodHelpList=true"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox v-model="form.postToGL" :label="labels.postToGL" data-vv-name="postToGL" :data-vv-as="labels.postToGL"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-calendar-range</v-icon>
          <v-toolbar-title>Selection Criteria</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field v-model="form.fund" :label="labels.fund" :error-messages="errors.collect('fund')"
                :data-vv-as="labels.fund" data-vv-name="fund" append-icon="mdi-magnify"
                readonly v-validate="'required'"
                :loading="submitting"
                @click:append="showFundHelpList=true"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-checkbox v-model="form.combineFundsReport" :label="labels.combineFundsReport" data-vv-name="combineFundsReport" :data-vv-as="labels.combineFundsReport"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-calendar-range</v-icon>
          <v-toolbar-title>UPR Calculation Method</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-radio-group v-model="form.uprCalcMethod" :mandatory="true" row>
                  <v-radio :label="labels._1ovr24Month" :value="select._1ovr24Month"></v-radio>
                  <!-- v-radio :label="labels._1ovr48Month" :value="select._1ovr48Month"></v-radio -->
                  <!-- v-radio :label="labels._1ovr72Month" :value="select._1ovr72Month"></v-radio -->
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
       <v-spacer class="mt-2"></v-spacer>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex lg6 xs12>
            <v-btn class="mr-2" color="error" dark @click.prevent="doCancel">
              {{labels.cancel}}
              <v-icon dark right>mdi-exit-to-app</v-icon>
            </v-btn>
            <batch-job-schedule :parentForm="parentForm" :jobNames="defaultJobNames" :showJobMode="false"></batch-job-schedule>
            <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.submit}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                {{format.label}}
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
       <v-dialog v-model="showAcctPeriodHelpList" width="1280px">
        <acct-period-help-list @close="showAcctPeriodHelpList = false" @assign-acct-period-info="assignAcctPeriod" :boolRefresh="showAcctPeriodHelpList" :modeNo="modeNo"></acct-period-help-list>
      </v-dialog>
      <v-dialog v-model="showFundHelpList" width="900px" persistent>
        <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignFund($event)" />
      </v-dialog>
    </form>
  </page>
</template>
<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import clone from 'clone'
import MessageMixin from '@/mixins/message'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import AcctPeriodHelpList from '@/components/core/common/dialog/AcctPeriodHelpList'
import BatchJobSchedule from '@/components/core/common/BatchJobSchedule'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        acctPer: 'Accounting Period (Month/Year)',
        postToGL: 'Post to GL',
        fund: 'Funds',
        combineFundsReport: 'Combine Funds Report',
        uprCalcMethod: 'UPR Calculation Method',
        _1ovr24Month: '1/24 Month',
        _1ovr48Month: '1/48 Month',
        _1ovr72Month: '1/72 Month',
        cancel: 'Cancel',
        schedule: 'Schedule',
        submit: 'Submit'
      },
      select: {
        _1ovr24Month: 24,
        _1ovr48Month: 48,
        _1ovr72Month: 72
      },
      form: {
        acctPer: null,
        postToGL: false,
        fund: 'All',
        combineFundsReport: false,
        uprCalcMethod: 24
      },
      menu: {},
      submitting: false,
      showFundHelpList: false,
      showAcctPeriodHelpList: false,
      modeNo: '3',
      tempAcctPer: {},
      defaultJobNames: [
        { label: 'Batch UPR Annual and GL', value: 'qrtzUPRAnnualAndGL' }
      ]
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doClose() {
      this.showFundHelpList = false
    },
    async doAssignFund(obj) {
      this.form.fund = []
      this.form.fund = obj.finalSelectedItems.toString()
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.form)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doInit() {
      await this.setMenu()
      let tranDate = new Date()
      this.getAcctPer('tempAcctPer', '3', formatDisplayDateTime2(tranDate)).then((result) => {
        if (result) {
          this.form.acctPer = this.tempAcctPer.acctMth + '/' + this.tempAcctPer.acctYr
        }
      })
    },
    async setMenu() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.uprAnnualAndGL
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.menu = extractMenu(data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doCancel() {
      this.$router.push({ name: 'reportAcct' })
    },
    assignAcctPeriod(data) {
      this.resetValidator()
      this.resetMessages()
      this.form.acctPer = data.acctPerMth + '/' + data.acctPerYr
      this.showAcctPeriodHelpList = false
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      result.push(reportFormat.PDF)
      result.push(reportFormat.XLSX)
      return result
    },
    parentForm() {
      return this.form
    }
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    MultiFundHelpList,
    AcctPeriodHelpList,
    BatchJobSchedule
  }
}
</script>
